module.exports = __webpack_public_path__ + "static/media/SpinnerLight.260c9584.svg";